import React, { useState } from "react";
import _ from "lodash";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

import AddonCard from "./addons/addon_cards";
import { FiCheckCircle } from "react-icons/fi";
import { useConfig } from "../../hooks/use-config";

const StyledContainer = styled(Container)`
  .addon-carousel-container {
    margin-top: 16px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
  }

  .addon-slide {
    display: flex;
    justify-content: center;
    padding: 18px 36px;
  }

  .custom-carousel {
    position: relative;
    padding-top: 22px;
    padding-bottom: 38px;
  }

  .custom-carousel .carousel-indicators {
    display: flex !important;
    bottom: 8px;
    margin-bottom: 0;
  }

  .custom-carousel .carousel-indicators button {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    opacity: 0.45;
    background-color: #fff !important;
  }

  .custom-carousel .carousel-indicators .active {
    opacity: 1;
    background-color: #f39c12 !important;
  }

  .addon-shell {
    width: 100%;
    max-width: 900px;
    background: #fff;
    border: 1px solid #e9e9e9;
    border-radius: 8px;
    padding: 26px 30px 18px;
    display: flex;
    flex-direction: column;
    min-height: 0x;
  }

  .addon-shell-inner {
    display: flex;
    gap: 34px;
    align-items: flex-start;
    flex: 1 1 auto;
  }

  .addon-shell-left {
    flex: 0 0 54%;
    min-width: 320px;
  }

  .addon-shell-right {
    flex: 1 1 auto;
    min-width: 280px;
    padding-top: 21px;
  }

  .use-cases-list {
    margin: 0;
    padding-left: 0;
    list-style: none;
    text-align: left;
  }

  .use-cases-list li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 12px;
    line-height: 1.35;
  }

  .use-cases-list li::before {
    content: none;
  }

  .benefit-icon {
    margin-top: 2px;
    font-size: 18px;
    flex: 0 0 auto;
  }

  .addon-cta-row {
    margin-top: auto;
    display: flex;
    justify-content: center;
    // padding-top: 18px;
  }

  .addon-cta-btn {
    border: 1px solid #ffa700;
    background: #fff;
    color: #ffa700;
    border-radius: 3px;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .addon-cta-btn:hover {
    background: #ffa700;
    color: #fff;
  }

  .custom-carousel .carousel-inner {
    min-height: 320px;
  }

  .custom-carousel .carousel-item,
  .custom-carousel .carousel-item.active,
  .custom-carousel .carousel-item-next,
  .custom-carousel .carousel-item-prev {
    height: 320px;
  }

  .addon-slide {
    height: 320px;
    display: flex;
    justify-content: center;
  }

  .addon-shell {
    height: 320px;
    min-height: 0;
  }

  .addon-shell-inner {
    height: 100%;
    min-height: 0;
  }

  .addon-shell-right {
    min-height: 0;
    // overflow-y: auto;
    padding-right: 6px;
  }

  @media (max-width: 992px) {
    .custom-carousel .carousel-inner {
      min-height: 460px;
    }

    .custom-carousel .carousel-item,
    .custom-carousel .carousel-item.active,
    .custom-carousel .carousel-item-next,
    .custom-carousel .carousel-item-prev {
      height: 460px;
    }

    .addon-slide {
      height: 460px;
    }

    .addon-shell {
      height: 460px;
    }
  }

  @media (max-width: 992px) {
    .addon-shell {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }

    .addon-slide {
      padding: 14px 12px;
    }

    .addon-shell-inner {
      gap: 20px;
    }

    .addon-shell-inner {
      flex-direction: column;
    }

    .addon-shell-right {
      padding-top: 0;
    }

    .pricing-addons-container {
      width: 100%;
      padding: 0;
    }

    .addon-shell-left,
    .addon-shell-right {
      min-width: 0;
    }

    .addon-shell-right {
      padding-left: 0;
    }

    .use-cases-list li {
      gap: 8px;
      margin-bottom: 8px;
      line-height: 1.25;
      font-size: 13px;
    }

    .benefit-icon {
      font-size: 16px;
      margin-top: 1px;
    }

    .addon-cta-row {
      padding-top: 14px;
    }
    .addon-cta-btn {
      width: 100%;
      max-width: 280px;
    }
  }
`;

const AddonProducts = ({ addons, currency }) => {
  const { clearout: clearoutConfig } = useConfig();
  const [activeIndex, setActiveIndex] = useState(0);
  if (_.isEmpty(addons)) return null;

  return (
    <StyledContainer>
      <div className="pricing-addons-container container-lg text-center">
        <h2 className="text-center fw-bold">Handy Add-ons Features</h2>
        <span>Scale speed, concurrency, and reliability on your terms</span>

        <div className="addon-carousel-container">
          <Carousel
            indicators={true}
            variant="dark"
            interval={5000}
            activeIndex={activeIndex}
            controls={false}
            onSelect={(i) => setActiveIndex(i)}
            className="custom-carousel"
          >
            {addons.map((addon, index) => {
              const benefits = addon?.benefits || [];

              return (
                <Carousel.Item key={index}>
                  <div className="addon-slide">
                    <div className="addon-shell">
                      <div className="addon-shell-inner">
                        <div className="addon-shell-left">
                          <AddonCard addon={addon} currency={currency} />
                        </div>

                        <div className="addon-shell-right">
                          {benefits?.length ? (
                            <ul className="use-cases-list">
                              {benefits.map((b, i) => (
                                <li key={i}>
                                  <FiCheckCircle className="benefit-icon" />
                                  <span>{b}</span>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <div style={{ textAlign: "left" }}>
                              Easily opt for extra needs by choosing the right
                              combination with your plan
                            </div>
                          )}
                        </div>
                      </div>

                      {addon?.button ? (
                        <div className="addon-cta-row mb-3">
                          <a
                            href={clearoutConfig.app.baseUrl + "/pricing"}
                            className="addon-cta-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {addon.button}
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      </div>
    </StyledContainer>
  );
};

export default AddonProducts;
